import { useBreakpointValue } from "@gluestack-style/react";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";

export const WithdrawReceiptController = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { replace } = useNavigation();

  const handleGoToSales = () => {
    replace(ROUTES.sales);
  };
  return {
    isMobile,
    handleGoToSales
  };
};
